import { render, staticRenderFns } from "./ParticipantClaims.vue?vue&type=template&id=f5bd0bde&scoped=true"
import script from "./ParticipantClaims.vue?vue&type=script&lang=js"
export * from "./ParticipantClaims.vue?vue&type=script&lang=js"
import style0 from "./ParticipantClaims.vue?vue&type=style&index=0&id=f5bd0bde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5bd0bde",
  null
  
)

export default component.exports